export enum TransferringContributorType {
  REVOKE = 'revoke',
  PROMOTE = 'promote'
}